import PropTypes from 'prop-types';
import FooterMenu from './FooterMenu';

const FooterMenuContainer = ({ footerMenus }) => (
  <div className="footer__row footer__row--mid">
    <div className="footer__wrapper footer__wrapper--mid">
      <ul className="menu__list">
        {footerMenus.map(menu => (
          <FooterMenu key={menu.name} {...menu} />
        ))}
      </ul>
    </div>
  </div>
);

FooterMenuContainer.propTypes = {
  footerMenus: PropTypes.array.isRequired
};

export default FooterMenuContainer;
